<template>
  <v-btn
    flat
    :ripple="false"
    class="svg-button"
    :style="{
        'margin-left' : marginLeft + 'px',
        'margin-right' : marginRight + 'px',
        'width' : buttonWidth + 'px',
        'height': buttonHeight + 'px',
        'z-index' : '20'
    }"
  >
      <slot ></slot>
  </v-btn>
</template>

<script>
export default {
    name: "SvgButton",
    props: {
      marginLeft: {
          type: Number,
          default: 0
      },
      marginRight: {
          type: Number,
          default: 0
      },
      buttonWidth: {
          type: Number,
          default: 36
      },
      buttonHeight: {
          type: Number,
          default: 36
      }
    },


}
</script>

<style scoped lang="scss">

.svg-button {
    min-width: 30px !important;
    font-weight: 400;
    border-radius: 50%;
    padding: 5px;
    display: flex;
    align-items: center;

    .btn__content {
        padding: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/common/components/shared/SvgButton.vue